import * as ReactGA from 'react-ga'
import { envConfig } from './envConfig'
import { ISchool } from '../interfaces/school.interface'

// only works for pages with getInitialProps or probably without automatic rendering https://nextjs.org/docs/api-reference/next.config.js/runtime-configuration
// import getConfig from 'next/config';

// Only holds serverRuntimeConfig and publicRuntimeConfig
// const {
//   // serverRuntimeConfig,
//   publicRuntimeConfig
// } = getConfig()
// // Will only be available on the server-side
// console.log(serverRuntimeConfig.mySecret)
// Will be available on both server-side and client-side
// console.log("env var", publicRuntimeConfig)

export const apiUrl_ = envConfig.NEXT_PUBLIC_API_URL

// export const baseS3AssetsUrl = "https://pledre-assets.s3.us-east-2.amazonaws.com/public-images/"

export const StoreUserAuthToken = (token: string) => {
  if (token) {
    return localStorage.setItem('user_token', token)
  }
}

export const StoreUserType = (type: string) => {
  if (type) {
    return localStorage.setItem('user_type', type)
  }
}

export const GetUserAuthToken = () => {
  // useful when school is loaded as an iframe from pledre account dashboard
  // and the localstorage data is to be overwritten by a url token
  // use the default user_token only if no user_token in url
  const myUrl = new URL(location.href)
  let urlUserToken = myUrl.searchParams.get('user_token')
  if (urlUserToken) {
    return urlUserToken
  }

  return (
    localStorage.getItem('user_token') || localStorage.getItem('auth_token')
  )
}

export const GetUserType = () => {
  // return localStorage.getItem("user_type");
  const details = localStorage.getItem('user_details')
  return details ? JSON.parse(details).user_type : undefined
}

export const StoreUserDetails = (details: any) => {
  details = JSON.stringify(details)
  return localStorage.setItem('user_details', details)
}

export const GetUserDetails = () => {
  const details = localStorage.getItem('user_details')
  return details ? JSON.parse(details) : undefined
}

export const StoreUserFaculties = (faculties: any) => {
  if (faculties) {
    faculties = JSON.stringify(faculties)
    return localStorage.setItem('user_faculties', faculties)
  } else {
    return localStorage.removeItem('user_faculties')
  }
}

export const GetUserFaculties = () => {
  const faculties = localStorage.getItem('user_faculties')
  return faculties ? JSON.parse(faculties) : undefined
}

export const GetSchoolDetails = () => {
  const details = localStorage.getItem('school_details')
  return details ? JSON.parse(details) : undefined
}

export const StoreSchoolDetails = (details: any) => {
  details = JSON.stringify(details)
  return localStorage.setItem('school_details', details)
}

export const GetNotificationsList = () => {
  const details = localStorage.getItem(`notifications`)
  return details ? JSON.parse(details) : undefined
}

export const StoreNotificationsList = (details: any) => {
  details = JSON.stringify(details)
  return localStorage.setItem(`notifications`, details)
}

export const StoreSchoolTopicDiscussion = (
  topic_id: string,
  course_id: string,
  _discussions: any[],
) => {
  let discussions = JSON.stringify(_discussions)
  return localStorage.setItem(
    `topic_discussion_${course_id}_${topic_id}`,
    discussions,
  )
}

export const StoreAllSchoolCoursesLocally = (courses: any) => {
  courses = JSON.stringify(courses)
  return localStorage.setItem(`school_courses`, courses)
}
export const StoreAllSchoolCategoriesLocally = (categories: any) => {
  categories = JSON.stringify(categories)
  return localStorage.setItem(`school_categories`, categories)
}

export const GetAllSchoolCategoriesLocally = () => {
  const categories = localStorage.getItem(`school_categories`)
  return categories ? JSON.parse(categories) : undefined
}

export const GetAllSchoolCoursesLocally = () => {
  const courses = localStorage.getItem(`school_courses`)
  return courses ? JSON.parse(courses) : undefined
}

export const SetAnalyticsUserDetails = () => {
  console.log('setting analytics')
  ReactGA.set(GetUserDetails() ? GetUserDetails() : {})
}

export const SetAnalyticsPageView = (name: string) => {
  ReactGA.pageview(name)
}

export const GetSchoolTopicDiscussion = (
  topic_id: string,
  course_id: string,
) => {
  const details = localStorage.getItem(
    `topic_discussion_${course_id}_${topic_id}`,
  )
  return details ? JSON.parse(details) : undefined
}

// export const GetAdminUserToken = () => {
//   return localStorage.getItem("auth_token");
// };

export const StoreSchoolCourseDiscussion = (
  course_id: string,
  topic_id: string | null,
  _discussions: any[],
) => {
  let discussions = JSON.stringify(_discussions)
  return localStorage.setItem(
    `course_discussion_${course_id}_${topic_id || 'null'}`,
    discussions,
  )
}

export const StoreCommunityPosts = (posts: Array<any>) => {
  let posts_string = JSON.stringify(posts)
  return localStorage.setItem(`community_posts`, posts_string)
}

export const GetCommunityPostsLocally = () => {
  const posts = localStorage.getItem(`community_posts`)
  return posts ? JSON.parse(posts) : undefined
}

export const GetSchoolCourseDiscussion = (
  course_id: string,
  topic_id: string | null,
) => {
  const details = localStorage.getItem(
    `course_discussion_${course_id}_${topic_id || 'null'}`,
  )
  return details ? JSON.parse(details) : undefined
}

export const isSingleClass = () => {
  // if onClient and location.hostname === class.pledre.com
  if (
    typeof localStorage !== 'undefined' &&
    (location.hostname === 'class.pledre.com' ||
      location.hostname === 'pledre.school')
  ) {
    return true
  } else {
    return false
  }
}

export const setURLQueryParameter = (key: string, value: string) => {
  let urlParams = new URLSearchParams(location.search)
  urlParams.set(key, value)
  console.log(urlParams.toString())
  history.replaceState(
    null,
    '',
    `${location.origin}${location.pathname}?${urlParams.toString()}`,
  )
}

export const pushURLQueryParameter = (key: string, value: string) => {
  let urlParams = new URLSearchParams(location.search)
  urlParams.set(key, value)
  console.log(urlParams.toString())
  history.pushState(
    null,
    '',
    `${location.origin}${location.pathname}?${urlParams.toString()}`,
  )
}

export const getURLQueryParameter = (key: string) => {
  const urlParams = new URLSearchParams(location.search)
  return urlParams.get(key)
}

export const removeURLQueryParameter = (key: string) => {
  const urlParams = new URLSearchParams(location.search)
  urlParams.delete(key)
  history.replaceState(
    null,
    '',
    `${location.origin}${location.pathname}?${urlParams.toString()}`,
  )
}

export const setClassroomUrlAsPreviewMode = () => {
  setURLQueryParameter('creator_preview', 'true')
}

export const removeClassroomUrlAsPreviewMode = () => {
  removeURLQueryParameter('creator_preview')
}

export const getClassroomUrlPreviewMode = () => {
  return getURLQueryParameter('creator_preview')
}

export const setURLTopicParameter = (topic_id: string) => {
  setURLQueryParameter('topic', topic_id)
  // let urlParams = new URLSearchParams(location.search);
  // urlParams.set("topic", topic_id);
  // console.log(urlParams.toString());
  // history.replaceState(
  //   null,
  //   "",
  //   `${location.origin}${location.pathname}?${urlParams.toString()}`
  // );
}

export const pushURLTopicParameter = (topic_id: string) => {
  const existingTopicId = getURLTopicParameter()
  if (existingTopicId !== topic_id) {
    pushURLQueryParameter('topic', topic_id)
  }
}

export const getURLTopicParameter = () => {
  // const urlParams = new URLSearchParams(location.search);
  // return urlParams.get("topic");
  return getURLQueryParameter('topic')
}

export const getSelectedCourseIdParameter = () => {
  return getURLQueryParameter('selected_course_id')
}

export const setSelectedCourseIdParameter = (selected_course_id: string) => {
  setURLQueryParameter('selected_course_id', selected_course_id)
}

export const Logo = 'public/logo.jpg'

export const allowImportCustomTheme = (schoolDetails: ISchool) => {
  return schoolDetails.email === 'demi@pledre.com'
}

export const StoreTopicRecommendationLocal = (opts: {
  courseId: string
  question: string
  answer: string
}) => {
  const details = JSON.stringify({
    question: opts.question,
    answer: opts.answer,
  })
  return localStorage.setItem(
    `course_topic_recommendation_${opts.courseId}`,
    details,
  )
}

export const GetTopicRecommendationLocal = (opts: { courseId: string }) => {
  const details = localStorage.getItem(
    `course_topic_recommendation_${opts.courseId}`,
  )
  return details ? JSON.parse(details) : undefined
}

export const StoreCourseAIQuestionAnswerLocal = (opts: {
  courseId: string
  question: string
  answer: string
}) => {
  const details = JSON.stringify({
    question: opts.question,
    answer: opts.answer,
  })
  return localStorage.setItem(
    `course_ai_question_answer_${opts.courseId}`,
    details,
  )
}

export const GetCourseAIQuestionAnswerLocal = (opts: { courseId: string }) => {
  const details = localStorage.getItem(
    `course_ai_question_answer_${opts.courseId}`,
  )
  return details ? JSON.parse(details) : undefined
}

export const HIDE_ALL_PRICES = true
